import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Collapse from '@material-ui/core/Collapse';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';
import SendIcon from '@material-ui/icons/Send';
import EmailIcon from '@material-ui/icons/Email';
import { Modal } from '@material-ui/core';
import moment from 'moment';
import { XMEI_PRIMARY_COLOR, MSG_ERRO } from '../../consts/common';
import DropZone from '../../components/DropZone';
import { onlyNumbers } from '../../utils/common';
import NotaTeste from './notateste';
import { instanceAxios } from '../../InstanceAxios';
import 'moment/locale/pt-br';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '60%',
    height: '60%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  certificado: {
    margin: '1%',
    width: '100%',
    padding: '1%',
  },
}));

const REGIMES_APURACAO_SIMPLES = [
  {
    codigo: 1,
    nome: 'Tudo pelo Simples Nacional — inclusive o imposto da prefeitura',
  },
  {
    codigo: 2,
    nome: 'Federais pelo Simples; o imposto da prefeitura é recolhido à parte',
  },
  {
    codigo: 3,
    nome: 'Todos recolhidos fora do Simples',
  },
];

const CAMPOS_IBS_CBS = {
  regime_apuracao_tributos_sn: 'regimeApuracaoTributosSN',
  codigo_tributacao_nacional: 'codigoTributacaoNacional',
  codigo_nbs: 'codigoNBS',
  classificacao_tributaria: 'classificacaoTributaria',
  situacao_tributaria: 'situacaoTributaria',
  codigo_indicador_operacao: 'codigoIndicadorOperacao',
  percentual_aproximado_tributos_sn: 'percentualAproximadoTributosSN',
};

function NotaFiscal({ empresa, empresaEnotas, handleUpdateEmpresaNfe }) {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [dadosObrigatorioMunicipio, setDadosObrigatorioMunicipio] = useState({
    regimesEspecialTributacao: [],
  });
  const [emitindo, setEmitindo] = useState({
    ok: false,
    message: 'Dados para a emissão de Notas não fornecidos',
  });
  const [openModal, setOpenModal] = useState(false);
  const [itemLista, setItemLista] = useState([]);
  const [modalAddFile, setModalAddFile] = useState(false);
  const [fileName, setFileName] = useState('');
  const [senhaCertificado, setSenhaCertificado] = useState('');
  const [vencimentoCertificado, setVencimentoCertificado] = useState(null);
  const [linkCertificado, setLinkCertificado] = useState(null);
  const [fileCertificado, setCertificado] = useState(null);
  const [idCertificado, setIdCertificado] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [msgAlert, setMsgAlert] = useState('');
  const [edicaoEnquadramentoFiscal, setEdicaoEnquadramentoFiscal] =
    useState(false);
  const [historicoFiscal, setHistoricoFiscal] = useState(null);
  const empresaNfe = empresa.EmpresaUsuarioNFE;
  const isSimplesNacional =
    Number(empresa.tipo_tributacao) === 2 ||
    empresa.TipoTributacao?.nome === 'SIMPLES NACIONAL';
  const camposEnquadramentoFiscal = [
    {
      campo: 'codigo_tributacao_nacional',
      label: 'Código de tributação nacional',
      tamanho: 6,
    },
    {
      campo: 'codigo_nbs',
      label: 'Código de serviço nacional (NBS)',
      tamanho: 9,
    },
    {
      campo: 'classificacao_tributaria',
      label: 'Classificação tributária',
      tamanho: 6,
    },
    {
      campo: 'situacao_tributaria',
      label: 'Situação tributária (CST)',
      tamanho: 3,
    },
    {
      campo: 'codigo_indicador_operacao',
      label: 'Indicador da operação',
      tamanho: 6,
    },
  ];
  const textoAuditoriaFiscal = historicoFiscal
    ? `Última alteração: ${
        historicoFiscal.User?.nome ||
        historicoFiscal.Usuario?.nome ||
        historicoFiscal.usuario?.nome ||
        'usuário identificado'
      } em ${moment(
        historicoFiscal.created_at || historicoFiscal.createdAt
      ).format('DD/MM/YYYY [às] HH:mm')} · canal ${historicoFiscal.canal}.`
    : 'Nenhuma edição manual registrada.';

  const preencherEmpresa = (empresaEnotas, regimes) => {
    const ok =
      empresaEnotas.status === 'Habilitada' &&
      empresaEnotas.dadosObrigatoriosPreenchidos &&
      empresaEnotas.certificadoDigital.nome &&
      (!dadosObrigatorioMunicipio.precisaEnviarEmail ||
        empresa.EmpresaUsuarioNFE.email_enviado);
    let message = '';
    if (ok) {
      message = 'Cliente apto a emissão de Nota Fiscal!';
    } else if (empresaEnotas.status !== 'Habilitada') {
      message = 'Dados para a emissão de Notas não fornecidos!';
    } else if (!empresaEnotas.dadosObrigatoriosPreenchidos) {
      message = 'Dados para a emissão de Notas incompletos!';
    } else if (!empresaEnotas.certificadoDigital.nome) {
      message = 'Cliente sem Certificado Digital!';
    } else if (
      dadosObrigatorioMunicipio.precisaEnviarEmail &&
      !empresa.EmpresaUsuarioNFE.email_enviado
    ) {
      message = 'Email prefeitura não enviado';
    }
    setEmitindo({
      ok,
      message,
    });
    const ret = regimes.filter(
      (r) => r.codigo === empresaEnotas.regimeEspecialTributacao
    );
    const obj = empresa.EmpresaUsuarioNFE;
    const dadosIbsCbs = empresaEnotas.ibsCbs || {};
    Object.entries(CAMPOS_IBS_CBS).forEach(([campoLocal, campoENotas]) => {
      if (Object.prototype.hasOwnProperty.call(dadosIbsCbs, campoLocal)) {
        obj[campoLocal] = dadosIbsCbs[campoLocal];
      } else if (
        Object.prototype.hasOwnProperty.call(dadosIbsCbs, campoENotas)
      ) {
        obj[campoLocal] = dadosIbsCbs[campoENotas];
      }
    });
    obj.id_enotas = empresaEnotas.id;
    obj.inscricao_municipal = empresaEnotas.inscricaoMunicipal;
    obj.regime_especial_tributacao = empresaEnotas.regimeEspecialTributacao;
    obj.descricao_regime_especial = ret.length !== 0 ? ret[0].nome : null;
    obj.aedf = empresaEnotas.aedf;
    obj.numero_serie_nf =
      empresaEnotas.configuracoesNFSeProducao &&
      empresaEnotas.configuracoesNFSeProducao.serieNFe
        ? empresaEnotas.configuracoesNFSeProducao.serieNFe
        : null;
    obj.numero_sequencial_nf =
      empresaEnotas.configuracoesNFSeProducao &&
      empresaEnotas.configuracoesNFSeProducao.sequencialNFe
        ? empresaEnotas.configuracoesNFSeProducao.sequencialNFe
        : null;
    obj.numero_sequencial_lote =
      empresaEnotas.configuracoesNFSeProducao &&
      empresaEnotas.configuracoesNFSeProducao.sequencialLoteNFe
        ? empresaEnotas.configuracoesNFSeProducao.sequencialLoteNFe
        : null;
    obj.login_insc_municipal = empresaEnotas.configuracoesNFSeProducao
      ? empresaEnotas.configuracoesNFSeProducao.usuarioAcessoProvedor
      : null;
    obj.token = empresaEnotas.configuracoesNFSeProducao
      ? empresaEnotas.configuracoesNFSeProducao.tokenAcessoProvedor
      : null;
    obj.codigo_servico_municipal = empresaEnotas.codigoServicoMunicipal
      ? empresaEnotas.codigoServicoMunicipal
      : getCodigoServicoMunicipal(empresa);
    obj.item_lista_servico = empresaEnotas.itemListaServicoLC116
      ? empresaEnotas.itemListaServicoLC116
      : '';
    obj.aliquota_iss = empresaEnotas.aliquotaIss;
    obj.descricao_servico = empresaEnotas.descricaoServico;
    const regimeApuracaoPreenchido =
      isSimplesNacional && !obj.regime_apuracao_tributos_sn;
    if (regimeApuracaoPreenchido) {
      obj.regime_apuracao_tributos_sn = 1;
    }
    handleUpdateEmpresaNfe(obj, regimeApuracaoPreenchido);
  };

  const baseDataCompany = () => {
    const obj = empresa.EmpresaUsuarioNFE;
    let regimeApuracaoPreenchido = false;
    // Adicionando codigo servico municipal baseando no CNAE
    if (!obj.codigo_servico_municipal) {
      obj.codigo_servico_municipal = getCodigoServicoMunicipal(empresa);
    }
    // Descrição de Serviço vazio
    if (!obj.descricao_servico) {
      obj.descricao_servico = 'PRESTAÇÃO DE SERVIÇO';
    }
    // Numero de Nota
    if (!obj.numero_sequencial_nf) {
      obj.numero_sequencial_nf = '1';
    }
    // Série de Nota
    if (!obj.numero_serie_nf) {
      obj.numero_serie_nf = 'UNICA';
    }
    // Lote de Nota
    if (!obj.numero_sequencial_lote) {
      obj.numero_sequencial_lote = '1';
    }
    if (isSimplesNacional && !obj.regime_apuracao_tributos_sn) {
      obj.regime_apuracao_tributos_sn = 1;
      regimeApuracaoPreenchido = true;
    }
    handleUpdateEmpresaNfe(obj, regimeApuracaoPreenchido);
  };

  const atualizaItemLista = async (busca = '') => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/itemlistaservico?busca=${busca}`)
      .then((res) => {
        setItemLista(res.data);
        getLei116Object(res.data);
      })
      .catch((err) => {
        console.log(err);
        setItemLista([]);
      });
  };

  const getLei116Object = (itemLista) => {
    const obj = empresa.EmpresaUsuarioNFE;
    const arraylei = itemLista.filter(
      (il) => il.codigo === onlyNumbers(obj.item_lista_servico)
    );
    obj.lei_116 = arraylei[0];
    handleUpdateEmpresaNfe(obj, false);
  };

  const openNfeModal = () => {
    /* if (
      !openModal &&
      dadosObrigatorioMunicipio.precisaEnviarEmail &&
      !empresa.EmpresaUsuarioNFE.email_enviado
    ) {
      setMsgAlert(
        "Email prefeitura não enviado,clique para salvar os dados e enviar o email!"
      );
      setTipoAlert("warning");
      setOpenAlert(true);
    } else {
      setOpenModal(!openModal);
    } */
    setOpenModal(!openModal);
  };

  const handleAddFile = () => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalAddFile}
        onClose={() => setModalAddFile(false)}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: 5,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <DropZone
            handleButtonClick={(file) => {
              setModalAddFile(false);
              if (file) {
                setCertificado(file[0]);
                setFileName(file[0].name);
              }
            }}
          />
        </div>
      </Modal>
    );
  };

  const buscarCertificado = async () => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/certificadoDigital/${empresa.id}`)
      .then((res) => {
        if (res.data) {
          setCertificado(true);
          setFileName(res.data.nome_arquivo);
          setIdCertificado(res.data.id);
          setSenhaCertificado(res.data.senha);
          setVencimentoCertificado(res.data.data_validade);
          setLinkCertificado(res.data.certificado_path);
        }
      })
      .catch((err) => {
        console.log(err);
        setFileName('');
        setIdCertificado('');
        setSenhaCertificado('');
        setLinkCertificado(null);
      });
  };

  const enviarCertificado = async () => {
    // Checando se dados foram preenchidos
    if (!fileCertificado || !senhaCertificado) {
      setMsgAlert('Adicione o certificado/senha!');
      setTipoAlert('warning');
      setOpenAlert(true);
      return;
    }

    // Checando se esta enviando o mesmo certificado
    if (fileCertificado === true) {
      setMsgAlert('Certificado já enviado!');
      setTipoAlert('warning');
      setOpenAlert(true);
      return;
    }

    const data = new FormData();
    data.append('files', fileCertificado);
    data.append('senha', senhaCertificado);
    data.append('id', idCertificado);
    data.append('nomeArquivo', fileName);
    data.append('idEmpresa', empresa.id);

    setReady(false);

    await instanceAxios(localStorage.getItem('toobiauth'))
      .post('/uploadCertificadoDigital', data)
      .then((res) => {
        setTipoAlert('success');
        setMsgAlert(
          `Certificado: ${res.data?.certificado_response?.certificado?.message}
          HubCount: ${res.data?.certificado_response?.hubCount?.message}
          Enotas: ${res.data?.certificado_response?.enotas?.message}`
        );

        setOpenAlert(true);
        setReady(true);
      })
      .catch((err) => {
        setTipoAlert('error');
        setMsgAlert(err.response.data.message);
        setOpenAlert(true);
      });
  };

  const sendEmail = async (cnpj) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/sendEmailPrefeitura`, {
        cnpj,
      })
      .then(async (res) => {
        setMsgAlert(res.data.message);
        setTipoAlert('success');
        setOpenAlert(true);
        setReady(true);
      })
      .catch((err) => {
        setReady(true);
        setMsgAlert('Erro ao enviar email, tente novamente mais tarde!');
        setTipoAlert('error');
        setOpenAlert(true);
        console.log(err);
      });
  };

  const deleteCertificado = async (certificado) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .delete(`/certificadoDigital/${certificado}`)
      .then((res) => {
        // Retirando dados Certificado
        setCertificado(false);
        setIdCertificado('');
        setSenhaCertificado('');
        setLinkCertificado(null);
        setFileName('');
        setVencimentoCertificado(null);
        // Alert
        setMsgAlert(res.data.message);
        setTipoAlert('Success');
        setOpenAlert(true);
        setReady(true);
      })
      .catch((err) => {
        const msg =
          err.response.data && err.response.data.message
            ? err.response.data.message
            : MSG_ERRO;
        setTipoAlert('error');
        setMsgAlert(msg);
        setOpenAlert(true);
        setReady(true);
      });
  };

  useEffect(() => {
    const buscarDadosObrigatorios = async (ibge) => {
      return await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/dadosObrigatorioMunicipio/${ibge}`)
        .then((resp) => {
          if (!resp.data.regimesEspecialTributacao) {
            resp.data.regimesEspecialTributacao = [];
          }
          setDadosObrigatorioMunicipio(resp.data);
          return resp.data.regimesEspecialTributacao;
        })
        .catch((err) => {
          console.log(err);
          setDadosObrigatorioMunicipio({ regimesEspecialTributacao: [] });
          return [];
        });
    };
    const fetchData = async () => {
      let regimes = [];
      if (empresa.ibge) {
        regimes = await buscarDadosObrigatorios(empresa.ibge);
      }

      const dadosEmpresaEnotas = Array.isArray(empresaEnotas)
        ? empresaEnotas[0]
        : empresaEnotas;
      if (dadosEmpresaEnotas) {
        preencherEmpresa(dadosEmpresaEnotas, regimes);
      }
      setReady(true);
    };

    fetchData();
    baseDataCompany();
    atualizaItemLista();
    buscarCertificado();
  }, []);

  const getCodigoServicoMunicipal = (empresa) =>
    empresa.ibge === '5201405' ? `${empresa.cnae}00` : empresa.cnae;

  return (
    <>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={() => setOpenAlert(!openAlert)}
      >
        <Alert severity={tipoAlert} onClick={() => setOpenAlert(!openAlert)}>
          {msgAlert}
        </Alert>
      </Snackbar>
      <Collapse in={!ready}>
        <Grid container spacing={3}>
          <CircularProgress className={classes.loading} />
        </Grid>
      </Collapse>
      <Collapse in={ready}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid justify="center" container>
              <Chip
                size="small"
                style={
                  emitindo.ok
                    ? { backgroundColor: '#32CD32' }
                    : { backgroundColor: '#FF4500' }
                }
                label={emitindo.message}
                onClick={emitindo.ok ? openNfeModal : null}
              />
            </Grid>
          </Grid>
          <Grid item xs={3}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Aliquota ISS"
              fullWidth
              id="alquota_iss"
              label="Aliquota ISS"
              variant="outlined"
              type="number"
              InputProps={{ inputProps: { min: 0 } }}
              value={empresa.EmpresaUsuarioNFE.aliquota_iss}
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.aliquota_iss = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Percentual total de tributos — SN"
              fullWidth
              id="percentual_aproximado_tributos_sn"
              label="Percentual total de tributos — SN"
              variant="outlined"
              type="number"
              InputProps={{ inputProps: { min: 0, step: 0.01 } }}
              helperText="Lei 12.741/2012. Confirme com a sua contabilidade."
              value={
                empresaNfe.percentual_aproximado_tributos_sn === null ||
                empresaNfe.percentual_aproximado_tributos_sn === undefined
                  ? ''
                  : empresaNfe.percentual_aproximado_tributos_sn
              }
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.percentual_aproximado_tributos_sn = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Insc. Municipal"
              fullWidth
              id="inscricao_municipal"
              label="Inscrição Municipal"
              variant="outlined"
              type="number"
              InputProps={{ inputProps: { min: 0 } }}
              value={empresa.EmpresaUsuarioNFE.inscricao_municipal}
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.inscricao_municipal = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>
          {dadosObrigatorioMunicipio.usaAEDF ? (
            <Grid item xs={3}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder="AEDF"
                fullWidth
                id="aedf"
                label="AEDF"
                variant="outlined"
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                value={empresa.EmpresaUsuarioNFE.aedf}
                onChange={(event) => {
                  const obj = empresa.EmpresaUsuarioNFE;
                  obj.aedf = event.target.value;
                  handleUpdateEmpresaNfe(obj, true);
                }}
              />
            </Grid>
          ) : (
            <Grid item xs={3} />
          )}
          <Grid item xs={6}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Login da Pref."
              fullWidth
              id="login_insc_municipal"
              label="Login Prefeitura"
              variant="outlined"
              value={empresa.EmpresaUsuarioNFE.login_insc_municipal}
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.login_insc_municipal = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Senha da Pref."
              fullWidth
              id="senha_insc_municipal"
              label="Senha Prefeitura"
              variant="outlined"
              value={empresa.EmpresaUsuarioNFE.senha_insc_municipal}
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.senha_insc_municipal = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>

          {dadosObrigatorioMunicipio.deParaAutenticacao === 'Token' ||
          dadosObrigatorioMunicipio.deParaAutenticacao ===
            'UsuarioSenhaToken' ? (
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder="Token"
                id="token"
                label="Token Prefeitura"
                variant="outlined"
                value={empresa.EmpresaUsuarioNFE.token}
                onChange={(event) => {
                  const obj = empresa.EmpresaUsuarioNFE;
                  obj.token = event.target.value;
                  handleUpdateEmpresaNfe(obj, true);
                }}
              />
            </Grid>
          ) : (
            <Grid item xs={6} />
          )}
          {dadosObrigatorioMunicipio.usaDescricaoServico ? (
            <Grid item xs={12}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder="Descrição de Serviço"
                fullWidth
                multiline
                minRows={2}
                id="descricao_servico"
                label="Descrição Serviço"
                variant="outlined"
                value={
                  empresa.EmpresaUsuarioNFE.descricao_servico
                    ? empresa.EmpresaUsuarioNFE.descricao_servico.replace(
                        '  ',
                        '\n'
                      )
                    : ''
                }
                onChange={(event) => {
                  const obj = empresa.EmpresaUsuarioNFE;
                  obj.descricao_servico = event.target.value;
                  handleUpdateEmpresaNfe(obj, true);
                }}
              />
            </Grid>
          ) : (
            <Grid item xs={12} />
          )}
          {dadosObrigatorioMunicipio.usaCodigoServicoMunicipal ? (
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                placeholder="Cod. Serviço Municipal"
                id="codigo_servico_municipal"
                label="Código Serviço Municipal"
                variant="outlined"
                InputProps={{ inputProps: { min: 0 } }}
                value={empresa.EmpresaUsuarioNFE.codigo_servico_municipal}
                onChange={(event) => {
                  const obj = empresa.EmpresaUsuarioNFE;
                  obj.codigo_servico_municipal = onlyNumbers(
                    event.target.value
                  );
                  handleUpdateEmpresaNfe(obj, true);
                }}
              />
            </Grid>
          ) : (
            <Grid item xs={6} />
          )}
          {dadosObrigatorioMunicipio.usaItemListaServico ? (
            <Grid item xs={6}>
              <Autocomplete
                id="autoCompleteItemLista"
                options={itemLista}
                fullWidth
                value={empresa.EmpresaUsuarioNFE.lei_116}
                getOptionLabel={(o) => `${o.codigo}-${o.descricao}`}
                onChange={(event, value) => {
                  const obj = empresa.EmpresaUsuarioNFE;
                  obj.item_lista_servico = value
                    ? onlyNumbers(value.codigo)
                    : '';
                  obj.lei_116 = value || { codigo: '', descricao: '' };
                  handleUpdateEmpresaNfe(obj, true);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Item Lista de Serviço"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
          ) : (
            <Grid item xs={6} />
          )}
          <Grid item xs={4}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Numero Nfe"
              fullWidth
              id="numero_sequencial_nf"
              label="Número Nota"
              variant="outlined"
              type="number"
              InputProps={{ inputProps: { min: 0 } }}
              value={empresa.EmpresaUsuarioNFE.numero_sequencial_nf}
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.numero_sequencial_nf = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Série Nfe"
              fullWidth
              id="numero_serie_nf"
              label="Série Nota"
              variant="outlined"
              value={empresa.EmpresaUsuarioNFE.numero_serie_nf}
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.numero_serie_nf = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Lote Nfe"
              fullWidth
              id="numero_sequencial_lote	"
              label="Lote Nota"
              variant="outlined"
              value={empresa.EmpresaUsuarioNFE.numero_sequencial_lote}
              onChange={(event) => {
                const obj = empresa.EmpresaUsuarioNFE;
                obj.numero_sequencial_lote = event.target.value;
                handleUpdateEmpresaNfe(obj, true);
              }}
            />
          </Grid>
          {dadosObrigatorioMunicipio.usaRegimeEspecialTributacao ? (
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder="Regime Tributação"
                fullWidth
                id="regime_especial_tributacao"
                label="Regime Especial Tributação"
                variant="outlined"
                select
                value={Number(
                  empresa.EmpresaUsuarioNFE.regime_especial_tributacao
                )}
                onChange={(event) => {
                  const obj = empresa.EmpresaUsuarioNFE;
                  const ret =
                    dadosObrigatorioMunicipio.regimesEspecialTributacao.filter(
                      (dom) => dom.codigo === event.target.value
                    );
                  obj.regime_especial_tributacao =
                    ret.length !== 0 ? ret[0].codigo : null;
                  obj.descricao_regime_especial =
                    ret.length !== 0 ? ret[0].nome : null;
                  handleUpdateEmpresaNfe(obj, true);
                }}
              >
                {dadosObrigatorioMunicipio.regimesEspecialTributacao.map(
                  (option) => (
                    <MenuItem key={option.codigo} value={option.codigo}>
                      {option.nome}
                    </MenuItem>
                  )
                )}
              </TextField>
            </Grid>
          ) : (
            <Grid item xs={6} />
          )}
          {isSimplesNacional ? (
            <Grid item xs={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                id="regime_apuracao_tributos_sn"
                label="Regime de Apuração — Simples Nacional"
                variant="outlined"
                select
                value={Number(empresaNfe.regime_apuracao_tributos_sn) || 1}
                helperText={
                  [2, 3].includes(
                    Number(empresaNfe.regime_apuracao_tributos_sn)
                  )
                    ? 'Confirme essa informação com a sua contabilidade — ela muda como o imposto da sua nota é apurado.'
                    : ''
                }
                onChange={(event) => {
                  const obj = empresa.EmpresaUsuarioNFE;
                  obj.regime_apuracao_tributos_sn = Number(event.target.value);
                  handleUpdateEmpresaNfe(obj, true);
                }}
              >
                {REGIMES_APURACAO_SIMPLES.map((option) => (
                  <MenuItem key={option.codigo} value={option.codigo}>
                    {option.nome}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          ) : (
            <Grid item xs={6} />
          )}
          {camposEnquadramentoFiscal.length > 0 ? (
            <Grid item xs={12}>
              <Paper elevation={3} style={{ padding: '16px' }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={9}>
                    <strong>Enquadramento fiscal</strong>
                    <div style={{ fontSize: '12px', marginTop: '4px' }}>
                      Preenchido automaticamente a partir do item de serviço.
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      fullWidth
                      color="primary"
                      variant="outlined"
                      onClick={() => setEdicaoEnquadramentoFiscal(true)}
                    >
                      EDITAR
                    </Button>
                  </Grid>
                  {camposEnquadramentoFiscal.map((campo) => (
                    <Grid item xs={4} key={campo.campo}>
                      <TextField
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        id={campo.campo}
                        label={campo.label}
                        variant="outlined"
                        disabled={!edicaoEnquadramentoFiscal}
                        value={empresaNfe[campo.campo] || ''}
                        inputProps={{ maxLength: campo.tamanho }}
                        onChange={(event) => {
                          const obj = empresa.EmpresaUsuarioNFE;
                          obj[campo.campo] = onlyNumbers(event.target.value);
                          handleUpdateEmpresaNfe(obj, true);
                        }}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12}>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      {textoAuditoriaFiscal}
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <div align="center">
              {['5208707', '5201405'].includes(empresa.ibge) &&
              !empresa.EmpresaUsuarioNFE.email_enviado ? (
                <Button
                  startIcon={<EmailIcon />}
                  variant="contained"
                  color="primary"
                  style={{
                    paddingTop: 10,
                  }}
                  onClick={() => sendEmail(empresa.cnpj)}
                >
                  Enviar Email
                </Button>
              ) : null}
            </div>
          </Grid>
          <Grid item xs={6} />
          <Paper elevation={3} className={classes.certificado}>
            <Grid container justify="center">
              Certificado Digital do Usuário
            </Grid>
            <Collapse in={!linkCertificado}>
              <Grid
                container
                justify="space-around"
                alignItems="center"
                style={{ paddingTop: '2%' }}
              >
                <Grid item>
                  <p
                    style={{
                      fontSize: '13px',
                      fontWeight: 'normal',
                      marginBottom: 5,
                    }}
                  >
                    Upload do Certificado
                  </p>
                  <Button
                    startIcon={<CloudUploadIcon />}
                    variant="contained"
                    style={{
                      backgroundColor: XMEI_PRIMARY_COLOR,
                      color: '#FFF',
                    }}
                    onClick={() => setModalAddFile(true)}
                  >
                    {fileName
                      ? fileName.length > 10
                        ? `${fileName.substr(0, 10)}...`
                        : fileName
                      : 'Upload'}
                  </Button>
                </Grid>
                <Grid item>
                  <TextField
                    id="standard-full-width"
                    label="Senha"
                    type="password"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(event) => {
                      setSenhaCertificado(event.target.value);
                    }}
                    error={false}
                    value={senhaCertificado}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </Collapse>
            <Collapse in={linkCertificado}>
              <Grid
                container
                justify="space-around"
                alignItems="center"
                style={{ marginTop: '2%' }}
              >
                <Grid item>
                  <Button
                    startIcon={<CloudDownloadIcon />}
                    fullWidth
                    variant="contained"
                    style={{
                      backgroundColor: XMEI_PRIMARY_COLOR,
                      color: '#FFF',
                    }}
                    href={linkCertificado}
                    target="_blank"
                  >
                    {fileName
                      ? fileName.length > 10
                        ? `${fileName.substr(0, 10)}...`
                        : fileName
                      : 'Download'}
                  </Button>
                </Grid>
                <Grid item>
                  <TextField
                    id="vencimento_certificado"
                    label="Vencimento"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    disabled
                    error={false}
                    value={moment(vencimentoCertificado).format('YYYY-MM-DD')}
                  />
                </Grid>
                <Grid item>
                  <Collapse in={linkCertificado}>
                    <Button
                      startIcon={<DeleteIcon />}
                      fullWidth
                      variant="contained"
                      color="secondary"
                      onClick={() => deleteCertificado(idCertificado)}
                    >
                      Deletar
                    </Button>
                  </Collapse>
                </Grid>
              </Grid>
            </Collapse>
            <Collapse in={!linkCertificado}>
              <Grid container direction="row" justify="center">
                <Button
                  startIcon={<SendIcon />}
                  size="small"
                  variant="contained"
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    marginTop: '5%',
                  }}
                  target="_blank"
                  onClick={enviarCertificado}
                >
                  Enviar
                </Button>
              </Grid>
            </Collapse>
            {handleAddFile()}
          </Paper>
        </Grid>
      </Collapse>

      <Modal open={openModal} onClose={openNfeModal}>
        <div className={classes.paper}>
          <NotaTeste idEmpresa={empresa.id} empresaEnotas={empresaEnotas} />
        </div>
      </Modal>
    </>
  );
}

export default NotaFiscal;
